import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import CardItem from "../components/cardItem"
class Korea extends Component {
	state={
		youshi:[
			{
				name:'经济发达，毕业发展前景良好',
				content:'世界的经济中心正向亚洲转移，韩国在过去的几十年中，平均经济增长为8.6%，作为"亚洲四小龙"在国际上经济地位非常显著。' +
					'中韩经贸交往日益频繁，韩国正致力于开拓中国这个巨大的市场，向中国的粉资逐年增加，涉足制造业、服务业、文化产业等领域，韩国企业急需一大批精通中韩语言，并具有海外留学背景的专业人才。',
			},
			{
				name:'世界教育最发达国家之一',
				content:'拥有700多所高等学府，教学设施教材先进一流，提供课程全面;师资雄厚，教学理念领先，历史上培养出多位诺贝尔奖获得者;' +
					'政府及私人企业为在校学生提供多种丰厚的奖学金及实习机会;海外留学生享受国民待遇，公费医疗，所获得的学历国际公认，升学率高达93%。',
			},
			{
				name:'文凭含金量高，学历世界认可',
				content:'韩国的学历、学位被世界广泛认可，韩国的较用众立滤以国立大字为主，而是以私立大学为主。韩国85%以上都为积竞严块口大一小如公为同公立大学。国立也很多。许多私立大学比国立大学所拥有的师资和数学设各更加先进。' +
					'像韩国最著名的三所大学延世大学，高丽大学，首尔国立大学，被韩国人称为SKY，其中高丽和延世就是私立大学。所以学成归来的留学生们完全不需要担心私立大学的学历不被承认。\n',
			},
			{
				name:'教育水准高，专业设置全面',
				content:'韩国拥有世界知名高等学府，专业设置广泛。半导体、造船、纺织、家用电器、汽车制造等专业都有很高的水准，而计算机应用、新闻媒体、经济学和商学科绝对是亚洲一流。还有韩国艺术氛围浓厚，是亚洲乃至世界文明的时尚之都，其服装、奢侈品设计专业都很闻名。',
			},
			{
				name:'自由选择专业，轻松入学',
				content:'根据韩国有关法律，不论公立或私一的高等院校都必须接受教育部监督。和我国类似，韩国学生要考入高等院校都受到严格的限制，因此竞争激烈。但是对留学生就宽松得多，没有苛刻的入学考试。只需通过韩国语能力等级测试（TOPIK）相应等级，' +
					'就可以申请包括名牌大学在内的高等学府。',
			},
			{
				name:'学历要求不高，无须语言成绩',
				content:'在中国接受过12年教育，无论是高中或中专、职高毕业的学生，不需要高考成绩，不需要韩语基础，均可以申请韩国大学的语言课程，进而成功就读韩国一流大学本科课程。',
			},
			{
				name:'担保金额低廉，签证成功率高有海外留学',
				content:'申请韩国留学，担保金低，一般为一万美金以上。韩国对外国留学生的政策非常宽松，申请学生签证手续便捷，办理周期短，签证获取率高。资格审查内容主要是申请人的修学能力和经济能力。',
			},
			{
				name:'中韩文化相近，地理位置优越',
				content:'韩国位于亚洲大陆东北部，朝鲜半岛的南半部，是大陆链接的由北向南伸展的半岛国家。东、南、西三面环海。全国国土的70%的山地和丘陵地带，西南部地势低，是一望无际的平原。和中国毗邻，文化相当接近，中国留学生能够快速适应韩国生活。',
			},
			{
				name:'多种丰厚奖学金',
				content:'韩国学校为学生提供了丰厚的奖学金，留学生进入韩国大学就读，基本上均可享受25%到50%幅度的学费减免，就读硕士课程的奖学金更为丰厚。',
			},
			{
				name:'生活环境舒适，留学性价比高',
				content:'韩国四季分明，气候清爽宜人。韩国首尔的消费水平和国内的大城市水平相当，甚至低于上海的水平，地方城市消费水平更低，留学韩国费用相当低廉，一年的费用大概8-10万人民币左右。',
			},
		],
		zhuanye:[
			{
				title:'国语国文',
				content:'语言的学习是基础，而在韩国，国语也就是韩语，当然这个专业并不仅仅局限于语言的学习，而是会探讨语言发展的实力和趋势，从而加深对韩国历史的了解。' +
					'这个专业课程学习的主要内容在文法、语音、文学和文学史之上，更适合学生进行学术研究，回国就业的优势不大，但是在韩国找工作非常容易。',
				img:require('../../static/images/korea03.jpg')
			},
			{
				title:'国际贸易',
				content:'韩国作为亚洲与世界交往最为密切的国家之一，拥有者良好的国际声誉，其国际贸易遍布世界，从理论到实践都非常丰富，在这里留学可以收获更好的经验。' +
					'课程的学习包括经济学、管理、营销和翻译等方面。专业的学习会结合经济学和运营学，培养目标是成为专业素质高的应变型人才。',
				img:require('../../static/images/korea04.jpg')
			},
			{
				title:'物流管理',
				content:'本专业主要培养那些掌握现代经济贸易，运输与物流理论和技能，并要具有扎实英语能力的国际贸易运输及物理管理经营型人才。 <br><br> 推荐院校：仁荷大学，中央大学，韩国航空大学，建国大学。',
				img:require('../../static/images/korea05.jpg')
			},
			{
				title:'设计',
				content:'韩流已经成为席卷整个世界的一股潮流，尤其是在服饰方面的内容，东大门和明洞，在我国已经成为淘宝爆款的代名词，其在服饰等方面的审美具有独特性。' +
					'服装设计这门聚焦于服饰的专业，在未来的表现是不容小觑的，而且这门专业毕业之后，大家如果不想从事服装设计，还可以进军时尚界，当记者或者写手。',
				img:require('../../static/images/korea06.jpg')
			},
			{
				title:'摄影',
				content:'目前这门专业正逐步走向大众的事业，不再直属于上流社会，摄影的专业学习，包括技术的理论学习和审美能力的培养，还需要对制作进行了解。未来毕业之后，' +
					'大家除了从事专业的摄影工作之外，还可以接触电影、电视、综艺等的拍摄，同样会有利于大家的社会性学习，而且工资也很不错。',
				img:require('../../static/images/korea07.jpg')
			},
			{
				title:'新闻传媒类专业',
				content:'本专业主要是研究不同的媒体具备的特征和讯息被大众接受的过程，并学习针对在各种社会组织内的传播交流形态和过程，以及特性研究和短信的制作的受用的过程及效果的学科研究。<br><br>推荐院校：庆熙大学，中央大学，东国大学，梨花女子大学。',
				img:require('../../static/images/korea08.jpg')
			},
			{
				title:'酒店观光',
				content:'本专业要求学生掌握经济管理基础理论知识，学习酒店和餐饮与旅游基础，培养学生具备酒店基本管理及服务能力。目前全球紧缺高级酒店管理人才，并出现供不应求的现象，近年此专业就业前景非常好。<br><br> 推荐院校：庆熙大学，世宗大学，京畿大学。',
				img:require('../../static/images/korea09.jpg')
			},
		]
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/korea01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>韩国简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								大韩民国，简称韩国。位于东北亚，是一个新兴的发达国家。位于亚洲大陆东北朝鲜半岛南部，东、南、两三面环海，面积9.96万平方公里。自60年代以来，韩网政府实行了"出口主导型"开发经济战略，
								推动了本服经济的飞速发展，在短短几十年里，由世界上最贫穷落后的国家之一，一跃成为中等发达国家，缔造了令世界属目的"汉江奇迹"。
							</div>
							<img className={'img'} src={require('../../static/images/korea02.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>韩国留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.youshi.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>韩国留学热门专业</span>
							<span className={'line'}/>
						</div>
						<div className={'zhuanye'}>
							{
								this.state.zhuanye.map((item,index)=>(
									<CardItem item={item} key={index}/>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Korea